import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { apiErrorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ShieldCheck, Sparkles } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role === "admin" || u.role === "staff") navigate("/admin");
      else if (u.role === "super_admin") navigate("/super-admin");
      else { toast.error("This account does not have clinic access"); }
    } catch (err) {
      toast.error(apiErrorMessage(err, "Login failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-mr-bg grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <div className="absolute inset-0 luxe-pattern" />
        <div className="absolute inset-0 grain" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="label-eyebrow text-white/60">Clinic Console</p>
          <h2 className="font-display text-3xl font-semibold mt-2 max-w-md">Run a loyalty programme that drives preventive care.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16">
        <div className="w-full max-w-md">
          <Link to="/" className="inline-flex items-center gap-2 mb-10">
            <div className="h-8 w-8 rounded-lg bg-mr-primary text-white flex items-center justify-center"><Sparkles className="h-4 w-4" /></div>
            <span className="font-display font-semibold text-mr-primary">MedRewards</span>
          </Link>
          <h1 className="font-display text-3xl font-semibold text-mr-primary flex items-center gap-2"><ShieldCheck className="h-7 w-7 text-mr-accent" /> Admin sign in</h1>
          <p className="text-mr-secondary mt-2">Manage your clinic&apos;s loyalty programme.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label>Email</Label>
              <Input data-testid="admin-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@clinic.com" className="mt-2 rounded-xl bg-white border-mr h-11" />
            </div>
            <div>
              <Label>Password</Label>
              <Input data-testid="admin-password-input" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-xl bg-white border-mr h-11" />
            </div>
            <Button data-testid="admin-submit-btn" type="submit" disabled={busy} className="w-full h-11 rounded-full bg-mr-primary hover:bg-[var(--mr-primary-hover)]">
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
